<template>
  <transition name="slide" appear>
    <div class="trip-summary-wrapper content-wrapper" ref="root">
      <MainMenuWithPreferences pageTitle="My Trip" class="header">
        <template slot="preferences-menu">
          <MenuTripPreferences />
        </template>
      </MainMenuWithPreferences>

      <div class="mobile-wrapper">
        <div class="mobile-overlay">
          <div class="img"></div>
          <div class="text-primary"><b>Access Trip Planner from your desktop browser</b></div>
          <div class="text-secondary">
            Mobile devices are currently not supported. Plan your next trip from your web browser on your computer or
            laptop.
          </div>
        </div>

        <div class="sidebar top-img-section" :class="{'map-active': isSummaryMapActive}">
          <TripBg :img="solutionImgComputed" class="bg-extender" :alt="destinationName" v-if="!isSummaryMapActive" />

          <div class="container stretched-container">
            <div class="stretched-container--map">
              <!--
              <PoweredByMobi class="powered-by-mobi-position" v-if="showPoweredByMobi" />
              -->
              <div class="actions">
                <div class="trip-actions-wrapper" v-if="!isLoading">
                  <div class="save-trip-dropdown-wrap">
                    <SaveButton v-if="isSolutionSaved" saved class="save-trip-btn saved"
                      >Trip <strong>Saved</strong></SaveButton
                    >
                    <SaveButton v-if="!isSolutionSaved" class="save-trip-btn" @click="saveDialog = true"
                      >Save Trip</SaveButton
                    >

                    <div class="save-trip-dropdown" v-if="isSolutionSaved && !removeLoading">
                      <small>Saved {{ tripSavedRelative() }} ago</small>
                      <button class="save-trip-action" @click="saveDialog = true">Rename</button>
                      <button class="save-trip-action rename-trip-action" @click="remove">Delete</button>
                    </div>
                  </div>
                  <TripActions
                    class="trip-actions"
                    :numberOfTravelers="numberOfTravelers"
                    :prices="price"
                    @book-trip="onBookingOpen"
                  />
                </div>
                <div class="map-toggle" :class="{active: isSummaryMapActive}">
                  <ToggleComponent :value="isSummaryMapActive" @change="onToggleSummaryMap" id="map-toggle-summary" />
                  <label for="map-toggle-summary" class="map-toggle-label">Show Map</label>
                </div>
              </div>
            </div>

            <div class="trip-name">
              <h1 class="trip-dest-name" :class="{'color-dark': isSummaryMapActive}">My Trip</h1>
              <div class="trip-name-hint" :class="{'color-dark': isSummaryMapActive}">{{ destinationName }}</div>
            </div>
            <transition name="fade-in">
              <div
                class="map-holder bg-extender"
                v-if="isSummaryMapActive"
                ref="top"
                :class="{active: isSummaryMapActive}"
              >
                <SolutionMap
                  :isMapActive="isSummaryMapActive"
                  :isMapFull="isSummaryMapActive"
                  @show-details="onShowPoiDetailsFromMap"
                >
                  <template v-slot:toggle>
                    <div></div>
                  </template>
                </SolutionMap>
              </div>
            </transition>
          </div>
        </div>

        <div ref="anchor"></div>

        <div class="mobiamex-tripsummary summaryView container" id="tripSummary">
          <div class="page-content">
            <div v-if="!isLoading" class="summery-page-destination">
              <div class="label">Destinations</div>
              <ContextSwitcher
                class="context-switcher"
                :contexts="availableContexts"
                @context-change="onSwitchContext"
              />
            </div>

            <div class="trip-samples">
              <div class="label t-title sm mb-m">Trip Summary</div>
            </div>

            <!-- trip summary cards -->
            <div class="tripDetails">
              <div class="summary-cards">
                <TripSummaryFlightCard
                  class="trip-summary-flight-card"
                  v-if="isFlightAvailable"
                  :isLoading="isLoading"
                  :images="flightsImg"
                  :label="flightDescription"
                  subTitle="Recommended Flight"
                  :title="airlines"
                  :price="flightPrice"
                  :isFlightsOn="isFlightsOn"
                  @toggle-flight="toggleFlight"
                  @set-arrival="handleSetArrival"
                  @select-click="onBookingOpen"
                  @details-click="onFlightsOpen"
                />
                <TripSummaryCard
                  :isLoading="isLoading"
                  :images="[stayImg]"
                  :subTitle="staySubTitle"
                  :title="stayNameDerived"
                  :price="stayPrice"
                  priceLabel="Per Night"
                  :isOn="isStaysOn"
                  :showToggle="true"
                  :preferenceSelected="true"
                  @toggle-exp="turnOffStay"
                  @details-click="onBookingOpen"
                  @itinerary-click="onHotelsOpen"
                />
                <TripSummaryCard
                  :isLoading="isLoading"
                  :images="dingingImages"
                  :subTitle="diningSubTitle"
                  :title="diningTitle"
                  :price="null"
                  priceLabel=""
                  firstButtonLabel="Itinerary"
                  secondButtonLabel="Explore"
                  :picks="diningPicks"
                  :showPicks="true"
                  :preferenceSelected="diningPreferenceSelected"
                  @preferences-click="onCommonFilterClick({type: 'INTERESTS'}, UserActivityCategoryEnum.DINING)"
                  @details-click="onDiningOpen"
                  @itinerary-click="handleItineraryClick"
                />
                <TripSummaryCard
                  :isLoading="isLoading"
                  :images="experienceImages"
                  :subTitle="experienceSubTitle"
                  :title="experienceTitle"
                  :price="null"
                  priceLabel=""
                  firstButtonLabel="Itinerary"
                  secondButtonLabel="Explore"
                  :preferenceSelected="experiencePreferenceSelected"
                  :picks="experiencePicks"
                  :showPicks="true"
                  @preferences-click="onCommonFilterClick({type: 'INTERESTS'}, UserActivityCategoryEnum.EXPERIENCE)"
                  @details-click="onExperiencesOpen"
                  @itinerary-click="handleItineraryClick"
                />
              </div>

              <div id="exp-card"></div>
            </div>
            <!-- trip summary cards -->
          </div>
        </div>
        <div class="itinerary-list container">
          <!-- TODO: #SNG remove v-if -->
          <ItineraryPreferences v-if="false" />
          <ItineraryList id="itinerary" :removedItems="removedItems" @show-recommendations="openRecommendations()" />
        </div>
        <div class="itinerary-list">
          <more-places :isLoading="isLoading" />
        </div>
        <PoweredByMobiFooter v-if="isFooterAvailable" class="full-width padded-top" />

        <div class="save-dialog" v-if="saveDialog">
          <SummarySaveDialog
            @download="onDownloadPdf"
            @save="onSaveTrip"
            @close="onCloseSaveTrip"
            :image="solutionImgComputed"
            :tripName="destinationName"
            :isPDFLoading="isPDFLoading"
          ></SummarySaveDialog>
          <div class="save-dialog__overlay" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
import {useParams} from '@/router/router';
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
import {MdDialog} from 'vue-material/dist/components';
import VueCompositionAPI, {onMounted, ref, computed} from '@vue/composition-api';
import SolutionMap from './solution-map';
import '@mobi-components/toggle/dist/toggle.css';
import MainMenuWithPreferences from '@components/main-menu/main-menu-with-preferences.vue';
import MenuTripPreferences from '@components/main-menu/menu-trip-preferences.vue';
import {TripActions, TripBg} from '@mobi-components/amex-bluesky-components';
import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import {useSummary} from './summary-page-helper';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';
import {ToggleComponent} from '@mobi-components/toggle';
import ItineraryList from './itinerary-list/itinerary-list.vue';
import MorePlaces from './more-places.vue';
import SummarySaveDialog from '@components/summary-page/summary-save-dialog';
import TripSummaryCard from '@common/card/trip-summary-card';
import TripSummaryFlightCard from '@common/card/trip-summary-flight-card';
// import PoweredByMobi from '@common/powered-by-mobi.vue';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import SaveButton from '@common/button/save-button.vue';
import {useSessionValidation} from '../explore-page/explore-page-helper';
import ContextSwitcher from '../old-home-page/multi-city-trip/context-switcher.vue';
import ItineraryPreferences from './itinerary-preferences/itinerary-preferences.vue';
import {removeTrip} from '@/store/api/remove-trip';
import {
  fetchMyTrips,
  getOrigin,
  updateTripPreferences,
  getAllSelectedFilters,
  toggleSolutionTags,
  getAllSolutionFilters,
  getSessionId,
  getMyTrips,
} from '@/store/state/helpers';
import {getUserId} from '@/services/auth';
import {getModalFilterConfig} from '../old-home-page/modal-filter.config';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {getAmexSolution} from '@/store/state/helpers';

Vue.use(VueCompositionAPI);
Vue.use(MdDialog);
Vue.use(MdModalDialog);

const allovedInterestDomains = [
  UserActivityCategoryEnum.ACCOMMODATION,
  UserActivityCategoryEnum.DINING,
  UserActivityCategoryEnum.EXPERIENCE,
  UserActivityCategoryEnum.TRIPPREFERENCE,
  UserActivityCategoryEnum.GEOLOCATION,
];

export default {
  name: 'SummaryPage',
  components: {
    SummarySaveDialog,
    TripActions,
    TripBg,
    ToggleComponent,
    SolutionMap,
    ItineraryList,
    MorePlaces,
    PoweredByMobiFooter,
    SaveButton,
    MainMenuWithPreferences,
    MenuTripPreferences,
    ContextSwitcher,
    TripSummaryCard,
    TripSummaryFlightCard,
    ItineraryPreferences,
    // PoweredByMobi,
  },

  setup(props, {root}) {
    const showPoweredByMobi = process.env.VUE_APP_THEME !== 'MOBI';
    const isSingaporeDemo = process.env.VUE_APP_THEME === 'SINGAPORE_DEMO';

    // const {tripId} = useSaveSolutionDialog(root);

    const removeLoading = ref(false);
    const {turnOffFlight, turnOffStay, isStaysOn, diningActivities, experienceActivities} = useSummary();

    const solutionFilters = computed(() => {
      return getAllSolutionFilters();
    });

    const selectedTags = computed(() => {
      return getAllSelectedFilters();
    });

    const diningTitle = computed(() => {
      return diningActivities()?.[0]
        ?.name.split(':')[1]
        .trim();
    });

    const diningSubTitle = computed(() => {
      if (!diningActivities()) return '';
      return diningActivities()?.length + ' Dining Places in your Itinerary';
    });

    const diningPicks = computed(() => {
      if (!diningActivities()) return '';
      return diningActivities()?.length + ' Great Picks';
    });

    const dingingImages = computed(() => {
      if (!diningActivities()) return [];
      const {images} = diningActivities()?.[0] || {};
      return images ? Object.values(images) : [];
    });

    const experienceTitle = computed(() => {
      return experienceActivities()?.[0]?.name;
    });

    const experienceSubTitle = computed(() => {
      if (!experienceActivities()) return '';
      return experienceActivities()?.length + ' Activities in your Itinerary';
    });

    const experiencePicks = computed(() => {
      if (!experienceActivities()) return '';
      return experienceActivities()?.length + ' Great Picks';
    });

    const experienceImages = computed(() => {
      if (!experienceActivities()) return [];
      const {images} = experienceActivities()?.[0] || {};
      return images ? Object.values(images) : [];
    });

    const origin = computed(() => {
      return getOrigin() || {};
    });

    const staySubTitle = computed(() => {
      return isStaysOn.value ? 'Recommended Stay' : 'Stay turned Off';
    });

    const experiencePreferenceSelected = computed(() => {
      return !!solutionFilters.value.filter((x) => x.domain === UserActivityCategoryEnum.EXPERIENCE && x.value).length;
    });

    const diningPreferenceSelected = computed(() => {
      return !!solutionFilters.value.filter((x) => x.domain === UserActivityCategoryEnum.DINING && x.value).length;
    });

    const updateCommonStoreTags = async (filters, selectedFilters) => {
      // toggle tags in store
      const filtersTurnedOff = filters.value.filter((x) => x.value).map((x) => ({...x, value: false}));
      await toggleSolutionTags([...filtersTurnedOff, ...selectedFilters]);

      // use updateTripPreferences to update problem without re-submittingit again.
      await updateTripPreferences();
    };

    const availableCommonInterests = computed(() => {
      return solutionFilters.value.filter((x) => allovedInterestDomains.includes(x.domain));
    });

    const solutionImgComputed = computed(() => {
      return isSingaporeDemo
        ? 'https://mobi-poi-data.s3.amazonaws.com/images/travel-planning/destinations/small/singapore.jpg'
        : solutionImg;
    });

    const tripId = computed(() => {
      const sessionId = getSessionId();
      const tripId = useParams().value.tripId;
      const savedTrips = getMyTrips().filter((x) => !x.autoSaved);
      const trip = savedTrips.find((x) => x.id === sessionId || x.id === tripId || x.tripId === tripId);
      return trip?.tripId || savedSolutionId.value;
    });

    const remove = async () => {
      removeLoading.value = true;

      await removeTrip(tripId.value, getUserId());
      await fetchMyTrips();
      removeLoading.value = false;
    };

    // TODO: refactor this in common piece of code for all pages
    const onCommonFilterClick = (filter, category) => {
      const modalForFilter = getModalFilterConfig(filter.type);
      if (modalForFilter) {
        const configs = {
          interestsConfig: {
            get availableTags() {
              return [...availableCommonInterests.value];
            },
            availableCategories: {
              [category]: true,
            },
            onSelectionChange: (tags) => updateCommonStoreTags(availableCommonInterests, tags),
          },
        };

        const config = configs[modalForFilter.key];
        root.$modal
          .show(modalForFilter.modal, config)
          .then((updatedFilters) => {
            updatedFilters && config.onSelectionChange(updatedFilters);
            getAmexSolution();
          })
          .catch(() => {
            config.onSelectionChange([]);
          });
      }
    };

    const toggleFlight = () => {
      turnOffFlight();
    };

    const toggleStay = () => {
      turnOffStay();
    };

    const handleSetArrival = () => {
      // console.log('set arrival');
    };

    const handleDetailsClick = () => {
      // console.log('details');
    };

    const handleItineraryClick = () => {
      const targetElement = document.querySelector('#itinerary');
      targetElement?.scrollIntoView({behavior: 'smooth'});
    };

    onMounted(() => {
      fetchMyTrips();
    });

    useSessionValidation();
    return {
      ...useSummary(root),
      removeLoading,
      remove,
      UserActivityCategoryEnum,
      solutionFilters,
      onCommonFilterClick,
      origin,
      toggleFlight,
      toggleStay,
      handleSetArrival,
      handleDetailsClick,
      staySubTitle,
      diningTitle,
      diningSubTitle,
      dingingImages,
      diningPicks,
      experienceTitle,
      experienceSubTitle,
      experiencePicks,
      experienceImages,
      selectedTags,
      experiencePreferenceSelected,
      diningPreferenceSelected,
      handleItineraryClick,
      showPoweredByMobi,
      solutionImgComputed,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../solution-views/vue-transitions.scss';
@import './save-solution-dropdown.scss';
.summery-page-destination {
  display: none;
}
.top-img-section {
  width: 100%;
  position: relative;
  left: 0;
  top: 0;
  box-sizing: content-box;
  z-index: 1;
  transition: all 0.3s ease;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  flex-grow: 1;
  height: 300px;
}

.top-img-section:after {
  content: '';
  position: absolute;
  bottom: 0;
  top: 50%;
  left: 0;
  right: 0;
  z-index: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
}

.top-img-section.map-active {
  height: 75vh;
}

.stretched-container {
  width: 100%;
  height: 100%;
  &--map {
    position: relative;
    max-width: var(--widthContainer, 1260px);
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }
}

.stretched-container .map-holder {
  width: 100vw;
}

.rename-trip-action {
  color: #ff8e93;
  border-top: 1px solid var(--border-color);
}

.page-content {
  position: relative;
  height: auto;
  width: 100%;
  padding: 50px 0;
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
}

.tripDetails {
  width: 100%;
  max-width: var(--page-container-width, 1260px);
  margin: 10px auto 0;
  flex-direction: row;
  box-shadow: none;
  border-radius: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
}

.trip-samples {
  width: 100%;
  max-width: var(--page-container-width, 1260px);
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
}
.label {
  font-size: 28px;
  padding: 20px 0px;
}
.trip-samples .samples {
  padding: 0 20px;
  flex-grow: 1;
}

.trip-samples .samples .sample {
  display: inline-block;
  margin-right: 5px;
  font-size: 14px;
  border: 1px solid #071d3b;
  border-radius: 20px;
  height: 24px;
  line-height: 25px;
  padding: 0 10px;
  position: relative;
  opacity: 0.7;
  transition: 0.3s ease opacity;
}

.trip-samples .samples .sample.active {
  background-color: #071d3b;
  color: #fff;
  opacity: 1;
}
.trip-samples .samples .sample.active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  border-radius: 2px;
  left: 50%;
  margin-left: -5px;
  width: 10px;
  height: 10px;
  background-color: #071d3b;
  transform: rotate(45deg);
}
.trip-samples .remove {
  font-weight: 700;
  font-size: 14px;
  color: #838e9d;
  padding-right: 20px;
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: right 2px;
  cursor: pointer;
}

.trip-name {
  position: absolute;
  z-index: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 0.8;
  display: inline-block;
  top: auto;
  bottom: 30px;
  z-index: 2;
  left: calc(50% - 1260px / 2);
}

.trip-dest-name {
  font-family: var(--font-family);
  font-size: 14px;
  color: #ffffff;
}

.trip-name-hint {
  font-family: var(--font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 38px;
  line-height: 22px;
  color: #ffffff;
  margin-top: 10px;
}

.color-dark {
  color: var(--font-color-dark);
}

.overviewImage {
  border-radius: 10px;
  border: 2px solid var(--border-color);
  background-size: 30px;
  background-position: center;
  background-repeat: no-repeat;
  width: 75px;
  height: 75px;
  overflow: hidden;
  position: relative;
}
.overviewImage.timeframe {
  background-image: url("data:image/svg+xml,%3Csvg width='31' height='34' viewBox='0 0 31 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.75 11.0167V27.15C0.75 28.7546 1.38741 30.2934 2.522 31.428C3.6566 32.5626 5.19544 33.2 6.8 33.2H24.95C26.5546 33.2 28.0934 32.5626 29.228 31.428C30.3626 30.2934 31 28.7546 31 27.15V11.0167C30.9986 9.588 30.4916 8.20592 29.5688 7.11521C28.646 6.02451 27.367 5.29555 25.9583 5.05743V0.93335H21.925V4.96668H17.8917V0.93335H13.8583V4.96668H9.825V0.93335H5.79167V5.05743C4.38296 5.29555 3.10398 6.02451 2.18121 7.11521C1.25845 8.20592 0.751448 9.588 0.75 11.0167ZM24.95 29.1667H6.8C6.26515 29.1667 5.7522 28.9542 5.374 28.576C4.9958 28.1978 4.78333 27.6849 4.78333 27.15V17.0667H26.9667V27.15C26.9667 27.6849 26.7542 28.1978 26.376 28.576C25.9978 28.9542 25.4849 29.1667 24.95 29.1667ZM6.8 9.00002H24.95C25.4849 9.00002 25.9978 9.21249 26.376 9.59068C26.7542 9.96888 26.9667 10.4818 26.9667 11.0167V13.0333H4.78333V11.0167C4.78333 10.4818 4.9958 9.96888 5.374 9.59068C5.7522 9.21249 6.26515 9.00002 6.8 9.00002Z' fill='%23CBD0D6'/%3E%3Cpath d='M11.8419 20.0917H7.80859V24.125H11.8419V20.0917Z' fill='%23CBD0D6'/%3E%3C/svg%3E%0A");
}

.overviewImage.withimages {
  border: 0px;
}

.overviewImage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.overviewImage.withimages > img:only-child {
  width: 75px;
  height: 75px;
}

.overviewImage.withimages > img {
  border-radius: 10px;
  width: 50px;
  height: 50px;
  position: absolute;
  background-color: #fff;
  object-fit: contain;
}
.overviewImage.flights > img {
  border: 2px solid var(--border-color);
}

.overviewImage.withimages img:first-child {
  top: 0;
  left: 0;
}

.overviewImage.withimages img:last-child {
  bottom: 0;
  right: 0;
}

.filter.button,
.filter-book-btn {
  padding-top: 18px;
  padding-bottom: 18px;
  min-width: 120px;
  color: #fff;
  border-radius: 4px;
  padding: 18px 20px 15px;
  text-align: left;
  position: relative;
  border: none;
  cursor: pointer;
  background-color: var(--btn-primary-color, hsl(208, 100%, 41%));
}

.filter.button:disabled {
  cursor: default;
  background-color: #e2e2e2;
  color: #6e6c6c;
  padding: 18px 20px 15px !important;
}

.filter-book-btn {
  border-radius: 4px;
  margin-right: 10px;
  min-width: auto;
}

.filter-book-btn + .filter.button {
  background-color: #e2e2e2;
  color: #6c6c6c;
  opacity: 1;
}

.filter-book-btn + .filter.button:hover {
  background-color: #e2e2e2;
}

.filter.button:disabled::after {
  content: none;
}

.filter.button:disabled:hover {
  background-color: #e2e2e2;
}

.filter.button:hover {
  background-color: hsl(214, 64%, 43%);
}

.filter.button::after {
  content: '';
  top: 0;
  right: 0;
  position: absolute;
  width: 40px;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='9' height='11' viewBox='0 0 9 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M9 5.50004L0.750001 10.2632L0.75 0.736944L9 5.50004Z' fill='%23c4c4c4'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='11' height='9' fill='%23c4c4c4' transform='translate(0 11) rotate(-90)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  background-size: 10px;
  background-position: center;
  background-repeat: no-repeat;
}

.filter .value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter .value.btn-long {
  width: 100px;
}

.perk {
  position: relative;
  border-radius: 4px;
  font-size: 13px;
  padding: 5px 10px 3px;
  display: inline-block;
  margin: 4px;
  position: relative;
  text-transform: capitalize;
  border: 1px solid var(--border-color);
}
.perk:first-child {
  margin-left: 0px;
}
.perk:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 12px;
  height: 12px;
  border-radius: 14px;
  background-color: #a3abb6;
  border: 2px solid #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 1px 1px;
  background-repeat: no-repeat;
}

.actions {
  display: flex;
  position: absolute;
  z-index: 2;
  top: auto;
  bottom: 30px;
  right: 0;
  //right: calc(50% - 630px);
}

.map-toggle {
  background: #ffffff;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  padding: 10px 20px;
  margin: 5px 0;

  transition: 0.3s ease opacity;
  --gray-scroll-thumb: #fff;
  --white: #fff;
  --toggle-bg: #dadada;
  border-radius: 4px !important;
  color: #838e9d;

  &.active {
    --toggle-bg: var(--btn-primary-color);
    --primary: #fff;
    .map-toggle-label {
      color: var(--btn-primary-color);
    }
  }
}

.map-holder {
  position: absolute;
  top: 0;
  left: 0;
  --map-height: 100%;
  width: 100%;
  transform: translateZ(0);
  z-index: 1;
}

.map-toggle > .map-toggle-label {
  margin: 0 0.5em;
  color: var(--toggle-text-color);
  position: relative;
  top: 2px;
  display: inline-block;
  font-weight: 400;
  font-size: 18px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
}

.trip-summary-wrapper {
  height: 100vh;
  overflow: auto;
}

.amex-header {
  --mobi-container-width: none;
  padding: 0 10px;
}

.trip-header {
  z-index: 10;
}

.bg-extender {
  top: 0;
  height: 100%;
}

.flight-alligner {
  text-align: left;
}

.flight-airlines {
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
}

.flight-details {
  padding: 5px 0 5px 25px;
}

.flight-details.underline {
  border-top: 1px solid #ededed;
}

.trip-cost {
  position: absolute;
  padding: 13px;
  top: 0;
  right: 0;
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 0px 0px 0px 20px;
  text-align: right;
  max-width: 125px;
}

.price-tag {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 118.14%;
  /* identical to box height, or 12px */

  text-align: right;
  letter-spacing: -0.005em;

  color: rgba(7, 29, 59, 0.37);
}

.price-label {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 118.14%;
  /* identical to box height, or 19px */

  text-align: right;
  letter-spacing: -0.005em;

  color: #071d3b;
}

.trip-actions {
  margin-left: auto;
}

.trip-card-actions {
  display: flex;
  overflow: hidden;
  justify-content: center;
}

.header-actions {
  display: flex;
  flex: 1;
}

.filters {
  display: flex;
  align-items: center;
  padding: 5px 0 20px;
  border-top: 1px solid #e5e5e5;
}

.see-all::after {
  display: none;
  opacity: 0;
}

.filter-value {
  white-space: nowrap;
}

.trip-loading {
  position: relative;
  top: 20px;
  display: inline-block !important;
  min-height: 60px;
}
.trip-loading:before {
  content: '';
  background: url('data:image/png+xml;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANiSURBVHgB3VVNa5xVFD7n3PvOO5NJMklRhjYzaZUgLtqiG0uYESK4cSHoQly46Eb/gH9C6FLc+gfEhS4EEcFYSwN+ILaIIFohQ2rGtKmTZpJ5P+45fd5+Jp1pPrprD7yf997znPucc55L9KQb7zlaP10tlWqvi4WXAvELwtbAgjKRXDHTrrEtpp2lLx4LwM+0XhPhD9hsktg8mXg8I2aqGIbJKMLlmbmrrJ+kyxc/H+XHjfoZzbTOOsfvMVkJISAIERLMNRMjgVPyZuTg3BPZNKa84WtNCRudpX0BSsfbb8Pjm1J8WOHeimvb1H4Wpu/V7Dc22sJIHd9VPAsQ+JG2m2hMhZud7x5JUWW23Qqm75Mx2CkWkg/Ovj6yvflZt3upvyuSxvxMLPIOKX3Iwt4AAmAnKme3Vn74aiRAudH6CPw+a8wCOpyw+3TQOX+e9rBKs/WuGn18m7ZindrGWL9y+saNb3u7KIoa7TNmdgbRGKIHO/Zl0rnwDe1j+Ubndzc9O12spTt5qaZR9ifycbkYlwdT7aQ4zvGSWbBeqvkFOqClbnAOMfX5bj4Q5Fv3xu4DAPooIigAcmb7g1Z+vE4HtSu/9Ih5CZcD6Q40vTwEgFqZwC3DhMxElumQxmqXkTdUNqMn6egwQAg5xnJUQsbBAh3SBmTnEuZ6wnQMz8YQAArzmrDk2Gamgt0c1jbjuOqy0ng0Fu38vZOilSIHGixl5edpbi6mA9uCp/Gk2s/Ea9r31BsFkNo/aoocWF7IQjl/Zp4Oao1kMhYXU2CvESqpvJEOAWTjtUtOfFFqBf/BcjlVOjH/4n6+a7Pt6ZKL6ljlYw/n2/i5o+sfaNH6X0FqTQDYCfCFXABEuekmmqrliU3aWkt3eV5Y8OVkppF6PcZBERIKHalMqvk1Wl9J7k0bkutys/Uquvgksh7UQg6tyaF2W87sqsZyPck0lEjH1Fw1QlvlitJWK3onpPlglVZ/Xdvpb0hN0frLMnUc50moo6IUghSgMahwHsO+jkCrpyJxlUA4BYob5CdyTAOzNbr60+rD/kaeB9pb/jeanLuJ1NeA5ElYUWHKDk0EZHg1Z9BN6Cd2m6Pu/6bOxf9G+dr7yCys/spz3jnICI+7SOKCjsC0Kab/p9u0TqfiLi0u5vTU2i2RZn5qNPtV/wAAAABJRU5ErkJggg==')
    no-repeat;
  background-position: 50%;
  background-size: contain;
  animation: spin infinite linear 1s;
  transform-origin: 50%;
  position: absolute;
  top: -1.5em;
  left: calc(50% - 0.5em);
  width: 1em;
  height: 1em;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.footer-caption {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 98.1%;
  text-align: center;
  letter-spacing: 0.01em;
  color: #97999b;
  display: flex;
  align-items: baseline;
  padding: 10px;
  justify-content: center;
}

.footer-caption .link-btn {
  border: none;
  background: none;
  appearance: none;
  cursor: pointer;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 98.1%;
  text-align: center;
  letter-spacing: 0.01em;
  color: var(--btn-primary-color, hsl(208, 100%, 41%));
  padding: 0;
  margin: 0 10px;
}

.disabled-label {
  --trip-section-label-color: #97999b;
}

.itinerary-scroll-target {
  padding-top: 60px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s linear;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
.find-dest-btn {
  display: flex;
  align-items: center;
  border: none;
  background: none;
  appearance: none;
  cursor: pointer;
  height: 40px;
  color: #2b70ca;
}

.find-dest-btn .image-holder {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin-right: 10px;
  overflow: hidden;

  border: 1px solid currentColor;
  display: flex;
  justify-content: center;
  align-items: center;
}

.find-dest-btn:not(:focus-within) .image-holder {
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("data:image/svg+xml, %3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.75 1V12.5' stroke='%233F7DCE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E%3Cpath d='M1 6.75L12.5 6.75' stroke='%233F7DCE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
}

.find-dest-btn:focus-within .image-holder {
  width: auto;
}

.find-dest-btn:focus-within .btn-caption {
  width: 0;
  opacity: 0;
}

.location-input {
  width: 100%;
  height: 100%;
  height: 40px;
  line-height: 40px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  color: #0c1e39;
  opacity: 0.9;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.75739 9.1716C6.96696 9.69512 6.01908 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 6.01908 9.69512 6.96696 9.1716 7.75739L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L7.75739 9.1716ZM8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5Z' fill='%23858E9C'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: 5px center;
  padding-left: 25px;
}

.find-dest-btn:not(:focus-within) .location-input {
  opacity: 0;
  width: 0;
}

.find-dest-btn:not(:focus-within) .longer {
  opacity: 0;
  pointer-events: none;
}

.find-dest-btn .location-input {
  opacity: 1;
  width: auto;
  will-change: width opacity;
  transition: min-width 0.3s linear;
}

.dropdown.longer {
  max-height: 300px;
  overflow: auto;
  left: auto;
  width: 350px;
}

.summary-cards {
  display: grid;
  flex-wrap: wrap;
  gap: 20px;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
}

.powered-by-mobi-position {
  position: absolute;
  right: 0%;
  top: 95px;
  z-index: 11;
}
</style>
